var he = require('he');

const Item = ( props ) => {
  let item = props.item

  return (
    <>
      <div className="events-archive__card" key={ item.ID }>
        <a className="events-archive__card-link" href={ item.permalink ?? '#' }>
          <div className="events-archive__image image-scale-effect-wrapper">
            {
              item.start_date && item.start_date.day && item.start_date.month && (
                <>
                  <div className="events-archive__image-date">
                    <span className="events-archive__image-day">{ item.start_date.day }</span>
                    <span className="events-archive__image-month">{ item.start_date.month }</span>
                  </div>
                </>
              )
            }

            {
              item.image && (
                            <div dangerouslySetInnerHTML={{ __html: item.image }} />
                      // <>
                      //   { he.decode( item.image ) }
                      // </>
              )
            }
          </div>
          <div className="events-archive__body">
            <h3 className="events-archive__title">{ he.decode( item.title ) }</h3>
            <div className={`events-archive__meta ${item.city ? 'has-city' : '' }`}>
              {
                item.city && (
                  <>
                    <div className="events-archive__meta-row">
                      <div className="events-archive__meta-value">
                        { he.decode( item.city ) }
                      </div>
                    </div>
                  </>
                )
              }
              {
                item.category && (
                  <>
                    <div className="events-archive__meta-row">
                    <label className="events-archive__meta-type">Kategori</label>
                      <div className="events-archive__meta-value">
                        { he.decode( item.category ) }
                      </div>
                    </div>
                  </>
                )
              }
              {
                item.type && (
                  <>
                    <div className={`events-archive__meta-row ${ item.type && item.type.toLowerCase() == 'fysisk' ? 'has-columns' : ''}`}>
                      {
                        item.region && item.type && item.type.toLowerCase() == 'fysisk' && (
                          <>
                            <div className="events-archive__meta-column">
                              <label className="events-archive__meta-type">Region</label>
                              <div className="events-archive__meta-value">
                                { he.decode( item.region ) }
                              </div>
                            </div>
                          </>
                        )
                      }
                      <div className="events-archive__meta-column">
                        <label className="events-archive__meta-type">Type</label>
                        <div className="events-archive__meta-value">
                          { he.decode( item.type ) }
                        </div>
                      </div>
                    </div>
                  </>
                )
              }
            </div>
            <div className="events-archive__link">Se arrangement<span className="events-archive__link-icon"></span></div>
          </div>
        </a>
      </div>
    </>
  )
}

export default Item;
